<template>
    <Overlay>
        <spring-spinner
            :animation-duration="animationDuration"
            :size="size"
            :color="color"
        />
    </Overlay>

</template>

<script setup>
import { SpringSpinner } from 'epic-spinners'
import Overlay from './Overlay.vue'

const props         = defineProps({

    animationDuration   : {
        type        : Number,
        default     : 1000,
    },

    size        : {
        type        : Number,
        default     : 65,
    },

    color       : {
        type        : String,
        default     : "#000",
    }
})
</script>